import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import QuestionnaireItem from './QuestionnaireItem';
import { Field } from 'redux-form';
import ValidationError from './ValidationError';

export class QuestionnaireFieldDate extends Component {
  renderInput(props) {
    // Get the date from the ISO String if present
    const value = props.input.value ? props.input.value.substring(0, 10) : null;
    return (
      <Fragment>
        {props.meta.error && <ValidationError key="error" error={props.meta.error} />}
        <input key="input" type="date" {...props.input} placeholder={props.placeholder} value={value} className="form-control" />
      </Fragment>
    );
  }

  render() {
    return (
      <QuestionnaireItem {...this.props}>
        <Field name={this.props.name} validate={this.props.validate} component={this.renderInput} placeholder={this.props.placeholder} />
      </QuestionnaireItem>
    );
  }
}

QuestionnaireFieldDate.defaultProps = {
  comments: true
};

QuestionnaireFieldDate.propTypes = {
  name: PropTypes.string.isRequired,
  prompt: PropTypes.string.isRequired,
  help: PropTypes.string,
  children: PropTypes.string,
  placeholder: PropTypes.string,
  comments: PropTypes.bool,
  validate: PropTypes.func,
  links: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }))
};

export default QuestionnaireFieldDate;